export { default } from './PartiuGpHero';
